import assetPath from '/opt/actions-runner/_work/crate/crate/packages/video/video-upload/src/assets/upload-success.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')